// removed by extract-text-webpack-plugin
module.exports = {"ms-container":"MonthlySavings__ms-container","msContainer":"MonthlySavings__ms-container","ms-margin":"MonthlySavings__ms-margin","msMargin":"MonthlySavings__ms-margin","savingicon":"MonthlySavings__savingicon","label24":"MonthlySavings__label24","label16":"MonthlySavings__label16","mslink":"MonthlySavings__mslink","details-link":"MonthlySavings__details-link","detailsLink":"MonthlySavings__details-link"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/MonthlySavings/MonthlySavings.scss
// module id = 2258
// module chunks = 8